import React from "react";
import AnalyticsTracker from "../components/AnalyticsTracker";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ThreatsBar from "../components/ThreatsBar";
import HowItWorks3 from "../components/HowItWorks3";
import Capabilities from "../components/Capabilities";
import AskRedline from "../components/AskRedline";
import ComparisonTable from "../components/ComparisonTable";
import Testimonials from "../components/Testimonials";
import { Coverage, FAQ } from "../components/CoverageFAQ";
import ConsultationCTA from "../components/ConsultationCTA";
import Footer from "../components/Footer";
import { useScrollReveal } from "../hooks/useScrollReveal";

export default function HomePage() {
  useScrollReveal();
  return (
    <div className="min-h-screen bg-white">
      <AnalyticsTracker
        pageName="Redline Monitoring Services Inc. - Home"
        customData={{ service_interest: "virtual_guards", page_type: "homepage" }}
      />
      <Header />
      <Hero />
      <ThreatsBar />
      <HowItWorks3 />
      <Capabilities />
      <AskRedline />
      <ComparisonTable />
      <Testimonials />
      <Coverage />
      <FAQ />
      <ConsultationCTA />
      <Footer />
    </div>
  );
}
